module.exports = __webpack_public_path__ + "static/media/etc.6d760fd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/img/etc.svg
// module id = 359
// module chunks = 0